import * as React from 'react';

import './style.scss';

interface ILoadingProps {
  show: boolean;
  onHide: any;
}

export default class Loading extends React.Component<ILoadingProps, {}> {
  public static defaultProps: ILoadingProps = {
    show: false,
    onHide: () => null,
  };

  render() {
    const wrapperStyle: React.CSSProperties = {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 99999,
      backgroundColor: '#ffffff',
    };

    const loaderStyle: React.CSSProperties = {
      position: 'absolute',
      left: 'calc(50% - 100px)',
      top: 'calc(50% - 100px)',
    };

    return (
      this.props.show && (
        <div style={wrapperStyle} role="region" aria-label="Page loading" aria-live="polite">
          <img style={loaderStyle} src="/assets/loading.gif" alt="Loading" />
        </div>
      )
    );
  }
}
